import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class UrlService {
	constructor() {}

	generarRutaUrl(origen: any, destino: any): string {
		const origenFormat = origen.toLowerCase().replace(/\s+/g, '-');
		const destinoFormat = destino.toLowerCase().replace(/\s+/g, '-');
		return `${origenFormat}-a-${destinoFormat}`;
	}
}
